<script lang="ts">
  // Mobile-Bottom-Tab-Bar. Auf <md sichtbar, daumenfreundliche
  // Hauptnavigation am unteren Bildschirmrand.
  //
  // Slice 2 IA-Refactor 2026-05-14: alle Section-Hubs sind primaer,
  // kein "Mehr"-Sheet mehr. Home + alle Bereiche (seit 18.10.2026 sieben,
  // mit Claude und Werkstatt) teilen sich die Breite. Labels sind
  // absichtlich kurz ("Sich." statt "Sicherheit") damit's auf 360px
  // noch lesbar bleibt. Active-State per sectionForPath; Home ist
  // Sonderfall (Pfad "/" oder leer).

  import Icon from "./Icon.svelte";
  import { navSections, sectionForPath } from "./nav-sections";
  import { router } from "./router.svelte";
  import { t } from "./i18n.svelte";
  import LaeuftInhalt from "./LaeuftInhalt.svelte";
  import LaeuftListe from "./LaeuftListe.svelte";
  import { buendle, type Buendel } from "./laeuft";
  import { navigate } from "./router.svelte";
  import { laeuftGerade, laeuftUhr } from "./laeuft.svelte";

  // Kurz-Label pro Section-Id; das Symbol kommt aus navSections.
  const kurz: Record<string, string> = {
    home: t("nav.short.home", "Zuhause"),
    werkstatt: t("nav.short.werkstatt", "Werkst."),
    infra: t("nav.short.infra", "Infra"),
    sec: t("nav.short.sec", "Sicher."),
    argus: t("nav.short.argus", "Argus"),
    system: t("nav.short.system", "System"),
    daten: t("nav.short.daten", "Daten"),
    claude: t("nav.short.claude", "Claude"),
  };

  const homeActive = $derived(router.current === "/" || router.current === "");

  // Läuft gerade (lib/laeuft.svelte.ts): am Telefon gibt es keine
  // Statusleiste -- eine schmale Zeile über den Tabs, der Tipp springt hin.
  // Gleichartiges als EIN Eintrag, der Tipp zeigt die Liste (LaeuftListe).
  const laeuft = $derived(buendle(laeuftGerade()));
  const uhr = laeuftUhr(() => laeuft.length > 0);
  let listeAuf = $state<{ id: string; anker: HTMLElement } | null>(null);
  const liste = $derived(listeAuf ? laeuft.find((b) => b.id === listeAuf!.id) : undefined);
  function laeuftTipp(b: Buendel, e: MouseEvent): void {
    listeAuf = listeAuf?.id === b.id ? null : { id: b.id, anker: e.currentTarget as HTMLElement };
  }
</script>

<!-- Tab-Bar selbst. md:hidden -> nur Mobile.
     KEIN fixed/absolute positioning -- die Bar ist Flex-Child des
     h-dvh-Wrappers in App.svelte und sitzt damit pixel-genau am
     unteren Rand (iOS-PWA-Bug, siehe feedback_mobile_flex_over_fixed).
     safe-area-bottom = Padding fuer den Home-Indicator. -->
<nav
  data-mobil-leiste
  class="md:hidden shrink-0 border-t border-border bg-bg-elev/90 backdrop-blur-xl safe-area-bottom"
  aria-label={t("nav.mobile", "Hauptnavigation")}
>
  {#if laeuft.length}
    <div class="border-border/60 flex gap-3 overflow-x-auto border-b px-3 py-1">
      {#each laeuft as b (b.id)}
        {@const klasse = `t-meta flex min-w-0 shrink-0 items-center gap-1.5 font-medium tabular-nums ${b.ton === "warn" ? "text-warning" : "text-fg"}`}
        {#snippet inhalt()}
          <span class="size-2 shrink-0 rounded-full {b.ton === 'laeuft' ? 'bg-laeuft' : b.ton === 'warn' ? 'bg-warning' : 'bg-fg-subtle'}"></span>
          <LaeuftInhalt {b} jetzt={uhr.jetzt} />
        {/snippet}
        {#if b.eintraege.length === 1}
          <a href={"#" + b.eintraege[0].pfad} title={b.titel} class={klasse}>{@render inhalt()}</a>
        {:else}
          <button type="button" title={b.titel} class={klasse} aria-haspopup="menu" aria-expanded={listeAuf?.id === b.id} onclick={(e) => laeuftTipp(b, e)}>{@render inhalt()}</button>
        {/if}
      {/each}
      {#if liste && liste.eintraege.length > 1 && listeAuf}
        <LaeuftListe eintraege={liste.eintraege} anker={listeAuf.anker} onwahl={(p) => navigate(p)} onzu={() => (listeAuf = null)} />
      {/if}
    </div>
  {/if}
  <div class="flex items-stretch justify-around px-0.5 pt-1">
    <a
      href="#/"
      class="flex flex-1 flex-col items-center gap-0.5 rounded-lg px-0.5 py-1.5 transition {homeActive
        ? 'text-accent'
        : 'text-fg-muted'}"
      aria-current={homeActive ? "page" : undefined}
    >
      <Icon name="home" size={20} />
      <span class="t-meta font-medium tracking-tight">{t("nav.dashboard.short", "Home")}</span>
    </a>
    {#each navSections as s (s.id)}
      {@const active = sectionForPath(router.current)?.id === s.id}
      <!-- data-bereich: mit „Bereichsfarbe als Ort" trägt der aktive
           Bereich seine Farbe (text-marke), mit „Symbole als Kacheln"
           jedes Symbol die seines Bereichs (app.css „Farbe"). -->
      <a
        href={"#" + s.href}
        data-bereich={s.id}
        class="flex flex-1 flex-col items-center gap-0.5 rounded-lg px-0.5 py-1.5 transition {active
          ? 'text-marke'
          : 'text-fg-muted'}"
        aria-current={active ? "page" : undefined}
      >
        <Icon name={s.icon} size={20} class="leisten-symbol" />
        <span class="t-meta font-medium tracking-tight">{kurz[s.id]}</span>
      </a>
    {/each}
  </div>
</nav>
